export const SET_ALL_DEAL_DATA = "SET_ALL_DEAL_DATA";
export const SET_APPLICATION_TYPE = "SET_APPLICATION_TYPE";
export const SET_ATTRIBUTE_CODES = "SET_ATTRIBUTE_CODES";
export const SET_CONTRACT_DURATIONS = "SET_CONTRACT_DURATIONS";
export const SET_CONTRACT_TYPES = "SET_CONTRACT_TYPES";
export const SET_DEAL_DETAILS = "SET_DEAL_DETAILS";
export const SET_DEAL_LIST = "SET_DEAL_LIST";
export const SET_DEVICE_COLOR = "SET_DEVICE_COLOR";
export const SET_DEVICE_COLOR_OPTIONS = "SET_DEVICE_COLOR_OPTIONS";
export const SET_DEVICE_DURATION_PRICE = "SET_DEVICE_DURATION_PRICE";
export const SET_INCLUSION_COLOR = "SET_INCLUSION_COLOR";
export const SET_RELATED_DEALS = "SET_RELATED_DEALS";
export const SET_SIMILAR_DEALS = "SET_SIMILAR_DEALS";
export const SET_WHITELISTED_ROUTERS = "SET_WHITELISTED_ROUTERS";
